/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RegisterReasonCodes = {
    Valid: 0,
    DataNotTrustworthyForBankId: 1000,
    IncompleteBankIdData: 1001,
    UnableToFindClientByBirthNumber: 1404,
    DataNotTrustworthyForLocal: 1804,
    FailedContractNumberValidation: 1805,
    ElectronicContactsUnavailable: 1806,
    FailedLocalRegistrationValidation: 1807,
    DeletedByCallCenter: 2000,
    MpkNotValid: 3000,
    MultipleMpkPendingValidation: 3001,
    DataNotTrustworthyTryContractNumber: 9000,
    RegisterInProgressStep1: -1000,
    RegisterInProgressStep2: -999
} as const;
export type RegisterReasonCodes = typeof RegisterReasonCodes[keyof typeof RegisterReasonCodes];


export function instanceOfRegisterReasonCodes(value: any): boolean {
    for (const key in RegisterReasonCodes) {
        if (Object.prototype.hasOwnProperty.call(RegisterReasonCodes, key)) {
            if (RegisterReasonCodes[key as keyof typeof RegisterReasonCodes] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RegisterReasonCodesFromJSON(json: any): RegisterReasonCodes {
    return RegisterReasonCodesFromJSONTyped(json, false);
}

export function RegisterReasonCodesFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterReasonCodes {
    return json as RegisterReasonCodes;
}

export function RegisterReasonCodesToJSON(value?: RegisterReasonCodes | null): any {
    return value as any;
}

export function RegisterReasonCodesToJSONTyped(value: any, ignoreDiscriminator: boolean): RegisterReasonCodes {
    return value as RegisterReasonCodes;
}

